'use client';

import { useTrackEventOnce } from '../hooks';

import type { EventData } from '../types';
import type { FC } from 'react';

type Props = {
  event: EventData;
};

export const TrackClientEvent: FC<Props> = ({ event }) => {
  useTrackEventOnce(event);

  return null;
};
